import { useLingui } from '@lingui/react/macro'
import { authHooks } from '$src/lib/trpcHooks'
import { useAuthStore } from '$src/store/useAuthStore'
import { Group, Menu, Text, UnstyledButton } from '@mantine/core'
import { IconChevronDown, IconLogout } from '@tabler/icons-react'

export function UserEmailBadge() {
  const { t } = useLingui()
  const user = useAuthStore((s) => s.user)
  const logout = useAuthStore((s) => s.logout)
  const logoutMutation = authHooks.useLogout()

  if (!user?.email) return null

  function handleLogout() {
    logoutMutation.mutate(undefined, { onSettled: logout })
  }

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <UnstyledButton>
          <Group gap={4}>
            <Text size="xs" c="dimmed" truncate>
              {user.email}
            </Text>
            <IconChevronDown size={14} color="var(--mantine-color-gray-5)" />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconLogout size={14} />}
          onClick={handleLogout}
        >
          {t`Log out`}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
